webpackJsonp([187272326130463],{

/***/ 358:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/blog/2018-06-21-contest-rules-and-tnc.md absPath of file >>> MarkdownRemark","html":"<p>We have increased the prize money to make the game more exciting. Following are the ways to get yourself enrolled... </p>\n<ul>\n<li>Tap into the contest tab of the app </li>\n<li>Hit join contest if you want to be a part of it</li>\n<li>Play the games mentioned in the \"Match List\" section</li>\n<li>Secure you place on the contest leaderboard to the get reward as mentioned in the \"See distribution\" CTA</li>\n<li>And Congratulations, you are the winner! </li>\n</ul>\n<p>Rooter reserves the right to change the prize money..</p>","frontmatter":{"date":"June 21, 2018","title":"Contest -Rules and TnC","description":"Test","tags":["TnC"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/blog/2018-06-21-contest-rules-and-tnc.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-2018-06-21-contest-rules-and-tnc-ed20b1b073fc8dc08286.js